import { CSSObject } from '@chakra-ui/react';

export const BadgeCountdown = (
  state: 'inprogress' | 'prior' | 'ended'
): CSSObject => ({
  '&&&&': {
    bg: () => {
      if (state === 'inprogress') {
        return 'blue.300';
      }
      if (state === 'ended') {
        return 'red.500';
      }
      // 'prior'
      return 'beta.800';
    },
    color: () => {
      if (state === 'inprogress') {
        return 'gray.700';
      }
      if (state === 'ended') {
        return 'white';
      }
      // 'prior'
      return 'white';
    },
    borderRadius: '4px',
    px: 1,
    fontFamily: 'roboto',
    fontWeight: 'bold',
    textTransform: state === 'prior' ? 'uppercase' : 'capitalize',
  },
  '&&': {
    h: '16px',
    maxH: '16px',
    minH: '16px',
    lineHeight: '16px',
  },
});
